import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import {fetchTable} from "../../api";

const IntradayHeatmap = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchTable("intraday_heatmap",'n50')
      .then((res) => setData(res))  // Axios puts JSON in res.data
      .catch((err) => console.error("Error fetching heatmap:", err));
  }, []);

  console.log('INTRADAY',data)
  const symbols = data.map((d) => d.symbol);
  const volumes = data.map((d) => (d.computed_volume/1e7).toFixed(2));
  const changes = data.map((d) => d.change_percent);

  return (
    <Plot
      data={[
        {
          type: "treemap",
          labels: symbols,
          parents: symbols.map(() => ""), // flat treemap
          values: volumes, // size by volume
          marker: {
            colors: changes,
            colorscale: [
              [0, "red"],
              [0.5, "yellow"],
              [1, "green"]
            ],
            colorbar: { title: "Change %" }
          },
          texttemplate: "%{label}<br>Vol %{value:.2f} Cr",
          textinfo: "label+value+ Cr entry",
        },
      ]}
      layout={{
        title: "Intraday Activity Heatmap",
        autosize: true,
        height: 600,
        width: 650,
      }}
    />
  );
};

export default IntradayHeatmap;

